import { Component, OnInit, AfterViewInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
declare var $: any;

@Component({
  selector: 'app-testimonial-videos',
  templateUrl: './testimonial-videos.component.html',
  styleUrls: ['./testimonial-videos.component.scss']
})
export class TestimonialVideosComponent implements OnInit, AfterViewInit {
  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (typeof $ !== 'undefined' && $('.popup-youtube').magnificPopup) {
        $('.popup-youtube').magnificPopup({
          disableOn: 320,
          type: 'iframe',
          mainClass: 'mfp-fade',
          removalDelay: 160,
          preloader: false,
          fixedContentPos: false
        });
      }
    }, 0);
  }

  videoSlides = [
    { 
      id: 'AGmeuBOaxH4',
      title: 'Kitchen Transformation',
      description: 'Beautiful kitchen tiles installation'
    },
    { 
      id: 'kx8a5GsWWQY',
      title: 'Bathroom Renovation',
      description: 'Luxurious bathroom makeover'
    },
    { 
      id: '-YNDCis8F7A',
      title: 'Living Room Makeover',
      description: 'Stunning living space transformation'
    },
    { 
      id: '8qdiNQ36yoY',
      title: 'Commercial Project',
      description: 'Office space tiles installation'
    },
    { 
      id: 'fvBmMvXAw7U',
      title: 'Outdoor Tiles',
      description: 'Beautiful outdoor patio tiles'
    }
  ];

  videoSliderOptions: OwlOptions = {
    loop: true,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayHoverPause: true,
    autoplayTimeout: 4000,
    autoplaySpeed: 800,
    smartSpeed: 800,
    margin: 24,
    navText: [
      "<i class='bx bx-chevron-left'></i>",
      "<i class='bx bx-chevron-right'></i>"
    ],
    responsive: {
      0: { items: 1 },
      576: { items: 2 },
      768: { items: 3 },
      1200: { items: 3 }
    }
  };

  getThumbnailUrl(videoId: string): string {
    return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
  }
}
